module.exports = __webpack_public_path__ + "static/media/16.f49a133f.jpg";